import { createFileRoute, Link } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export const Route = createFileRoute("/professional-terms")({
  head: () => ({
    meta: [
      { title: "Professional Terms — Peopels" },
      { name: "description", content: "Additional terms for Professionals (Helpers) using the Peopels platform, operated by Ashers Hub Ltd." },
    ],
    links: [{ rel: "canonical", href: "/professional-terms" }],
  }),
  component: Page,
});

function Page() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main id="main-content" className="mx-auto w-full max-w-3xl flex-1 px-4 py-16 sm:px-6 lg:px-8">
        <article className="prose max-w-none">
          <h1 className="font-display text-4xl font-bold">Professional Terms</h1>
          <p className="mt-2 text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString("en-GB")}</p>

          <p className="mt-6">
            These Professional Terms apply to anyone offering services on Peopels ("Professionals" or "Helpers").
            They supplement the <Link to="/terms" className="underline">Terms of Service</Link> between you and{" "}
            <strong>Ashers Hub Ltd</strong> (company number <strong>17204476</strong>).
          </p>

          <h2 className="mt-8 text-xl font-semibold">1. Independent contractor status</h2>
          <p>
            You operate as an independent contractor. Nothing in these Terms creates an employment, partnership or
            agency relationship with Ashers Hub Ltd.
          </p>

          <h2 className="mt-8 text-xl font-semibold">2. Accepting bookings</h2>
          <p>
            By accepting a booking you commit to perform the agreed work at the agreed time and location. You may
            begin allocating time, reserving availability and travelling to the job location on the strength of that
            acceptance.
          </p>

          <h2 className="mt-8 text-xl font-semibold">3. Cancellations &amp; reliability</h2>
          <p>
            Cancellations after acceptance are governed by the{" "}
            <Link to="/cancellation" className="underline">Cancellation Policy</Link>. Repeated cancellations,
            no-shows or late arrivals may result in reduced ranking, temporary suspension or removal from the platform.
          </p>

          <h2 className="mt-8 text-xl font-semibold">4. Fees &amp; payouts</h2>
          <p>
            A 10% platform fee is deducted from the agreed job value. Payouts are released from Stripe escrow once
            the booking is confirmed completed in line with the platform&apos;s payout schedule.
          </p>

          <h2 className="mt-8 text-xl font-semibold">5. Conduct &amp; safety</h2>
          <p>
            You agree to carry out work safely, lawfully and professionally, to comply with applicable UK laws and
            regulations, and to respect customers, their property and other platform users.
          </p>

          <h2 className="mt-8 text-xl font-semibold">6. Contact</h2>
          <p>Ashers Hub Ltd · Company No. 17204476 · helpers@peopels.com</p>
        </article>
      </main>
      <Footer />
    </div>
  );
}
